module.exports = __webpack_public_path__ + "img/splash_demo-400x300.9cc650df.jpg";